import { connect } from 'react-redux';
import NewComment from '../../components/comments/newcomment';

import { startComment } from '../../actions/ui';

const mapStateToProps = function(state) {
	return {
		visible: state.features["add_"+state.ui.comment_type] === true,
		selected_type: state.ui.comment_type,
		user: state.user,
		allow_add: {
			public: state.features.add_public,
			course: state.features.add_course,
			feedback: state.features.add_feedback,
			personal: state.features.add_personal
		},
		allow_comments: state.features.comments
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		startComment: (comment_type)=>dispatch(startComment(comment_type))
	};
}

const NewCommentContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(NewComment)

export default NewCommentContainer;